import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

export const { setPreviewsMergeData, setPreviewsMergeStatus } = slice.actions;

const previewsMerge = (url: any) => async () => {
  try {
    const response = await API.previewsMerge.previewsMerge(url);
    dispatch(setPreviewsMergeData(response.data));
    dispatch(setPreviewsMergeStatus(response.status));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {}
};

export default {
  previewsMerge
};
